module.exports = __webpack_public_path__ + "img/product-1.2553f37f.png";